import script from "./MerchantPersonalData.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantPersonalData.vue?vue&type=script&setup=true&lang=js"

import "./MerchantPersonalData.vue?vue&type=style&index=0&id=3451a3d6&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3451a3d6"]])

export default __exports__